import React, { forwardRef } from 'react';

// convertFormat=false opts out of the .webm probe — for slides whose
// source CDN we don't control (monarch, entertainment, peacock, nova,
// broadsign), the .webm variant is guaranteed to 404 and the multi-source
// walk delays first-frame playback against upstream CDNs we don't want
// to hammer.
const Video = forwardRef(({ src, children, convertFormat = true, ...props }, ref) => {
	if (!src) return <video ref={ref} {...props}>{children}</video>;

	if (!convertFormat) {
		return (
			<video ref={ref} {...props}>
				<source src={src} />
				{children}
			</video>
		);
	}

	const webmSrc = src.replace(/\.\w+(?=[?#]|$)/, '.webm');

	return (
		<video ref={ref} {...props}>
			<source src={webmSrc} type="video/webm" />
			<source src={src} />
			{children}
		</video>
	);
});

export default Video;
